import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TAppMaster } from '@monorepo/resolvers';
import {
  TLogApiRequest,
  TREQUEST_MASTER_DATA,
  TRESPONSE_BUSINESS_CONTEXT_ITEMS,
  TRESPONSE_MASTER_DATA,
  TRESPONSE_SHIFTS,
  TRESPONSE_TENANT_APPS,
  TREQUEST_SESSION_PLANS_DATA,
  TRESPONSE_SESSION_PLANS_DATA,
} from '@monorepo/types';
import { EnvironmentService } from '../activation/environment.service';
import { FactorEnvironmentService, ServiceEndPoints } from './factory-environment.service';

@Injectable({
  providedIn: 'root',
})
export class FactoryService {
  constructor(
    private http: HttpClient,
    @Inject(FactorEnvironmentService)
    private factoryEnvProvider: FactorEnvironmentService,
    @Inject(EnvironmentService) private envirProvider: EnvironmentService,
  ) {}

  getShifts(subject: string, subject_key: string, date: string) {
    const url = this.factoryEnvProvider.getEnvVar(ServiceEndPoints.GET_SHIFTS);

    const postBody = {
      subject,
      subject_key,
      date,
    };

    return this.http.post<TRESPONSE_SHIFTS>(url, postBody);
  }

  getSessionPlansBySubjects(payload: TREQUEST_SESSION_PLANS_DATA) {
    let url = this.factoryEnvProvider.getEnvVar(ServiceEndPoints.GET_SESSION_PLANS_BY_SUBJECTS);
    url = url.replace('/ext', '');
    //This API's URL doesn't include '/ext' after /shift_services, so we remove it
    return this.http.post<TRESPONSE_SESSION_PLANS_DATA>(url, payload);
  }

  getHeartBeat() {
    const url = this.factoryEnvProvider.getEnvVar(ServiceEndPoints.HEART_BEAT_API);
    return this.http.get<{ type: 'heart_beat'; response: 'ok' }>(url);
  }
  getBusinessContext(
    selectedBusinessContext: TAppMaster['apps'][0]['settingInfo']['bctx'][0],
    currentStation: TAppMaster['apps'][0]['settingInfo']['subjects'][0],
    allStationIds: TAppMaster['apps'][0]['settingInfo']['subjects'][0]['subject'][],
    clientInfo: TRESPONSE_TENANT_APPS['client_info'],
  ) {
    const url = this.factoryEnvProvider.getEnvVar(ServiceEndPoints.GET_BUSINESS_DATA);
    const postBody = {
      compress: false,
      agg_type: selectedBusinessContext.agg_type,
      bctx_keys: selectedBusinessContext.bctx_viz.map((item) => item.k),
      bctx_name:
        selectedBusinessContext.bctx_type === 'plan'
          ? selectedBusinessContext.plan_name
          : selectedBusinessContext.bctx_name,
      context: 'app',
      bctx_type: selectedBusinessContext.bctx_type,
      window: selectedBusinessContext.window,
      datetime: new Date().getTime(),
      hsk: currentStation.hsk || 'primary',
      subject_key: clientInfo.subject_key,
      subjects: allStationIds,
      server_wip_validation_enabled:
        selectedBusinessContext.qty_validation === 'WIP'
          ? true
          : !!selectedBusinessContext.server_wip_validation_enabled,
    };

    return this.http.post<TRESPONSE_BUSINESS_CONTEXT_ITEMS>(url, postBody);
  }

  getMasterDataList(client_info: TRESPONSE_TENANT_APPS['client_info'], masterDataList: string[]) {
    const reqBody: TREQUEST_MASTER_DATA = {
      query_name: 'get_all_lists',
      subject_key: client_info.subject_key,
      combinations: [
        {
          req_id: 'default',
          tags: ['default'],
          subject_key: client_info.subject_key,
          list_names: [...masterDataList],
        },
      ],
    };
    const url = this.factoryEnvProvider.getEnvVar(ServiceEndPoints.GET_DOMAIN_CNTXT);
    return this.http.post<TRESPONSE_MASTER_DATA>(url, reqBody);
  }

  sendLogstoBackend(logsToSend: TLogApiRequest[]) {
    const url = this.factoryEnvProvider.getEnvVar(ServiceEndPoints.BULK_LOGGING_API);
    const options = { headers: new HttpHeaders().set('responseType', 'text') };
    return this.http.post(url, { logErrorsRequests: logsToSend }, { responseType: 'text' });
  }

  getBulkLoggingAPI() {
    return this.factoryEnvProvider.getEnvVar(ServiceEndPoints.BULK_LOGGING_API);
  }
}
